import { isSimpleError, isSimpleErrors, SimpleError } from '@common/errors';
export class URLDecoder {
    allowedProtocols = ['https:'];
    allowPorts = false;
    constructor(options) {
        this.allowedProtocols = options?.allowedProtocols ?? this.allowedProtocols;
        this.allowPorts = options?.allowPorts ?? this.allowPorts;
    }
    decode(data) {
        const str = data.string;
        try {
            const parsed = new URL(str);
            if (!this.allowedProtocols.includes(parsed.protocol)) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Expected a valid URL at ${data.currentField} with protocol ${this.allowedProtocols.join(', ')}`,
                    field: data.currentField,
                });
            }
            if (!this.allowPorts && parsed.port !== '') {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Expected a valid URL without custom port at ${data.currentField}`,
                    field: data.currentField,
                });
            }
            if (parsed.username || parsed.password) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Expected a valid URL without username:password at ${data.currentField}`,
                    field: data.currentField,
                });
            }
            return parsed;
        }
        catch (e) {
            if (!isSimpleError(e) && !isSimpleErrors(e)) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Expected a valid URL at ${data.currentField}`,
                    field: data.currentField,
                });
            }
            throw e;
        }
    }
}
URL.prototype.encode = function (context) {
    return this.href;
};
//# sourceMappingURL=URLDecoder.js.map